/* NB Audio kit builder v1 (sb-speaker-kits, KIT_BUILDER_v1.md). One per kit product page.
   Reads its config from <script type="application/json" data-nba-kb-config> (the nb_kit.config metafield), prices and
   stock live from each part's /products/<handle>.js, and adds the chosen lines with /cart/add.js. */
(function () {
  "use strict";
  var money = function (cents) {
    return "$" + (cents / 100).toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };
  var esc = function (s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; });
  };

  function Builder(root) {
    this.root = root;
    this.cfg = JSON.parse(root.querySelector("[data-nba-kb-config]").textContent);
    this.v = {};            // variant id -> {price, available, title, url, handle}
    var c = this.cfg;
    this.state = {
      version: c.versions[0].id,
      finish: c.finishes.length ? c.finishes[0] : null,
      colour: c.colours.length ? c.colours[0].id : null,
      groups: {}
    };
    var self = this;
    c.groups.forEach(function (g) { self.state.groups[g.id] = true; });
    this.load();
  }

  Builder.prototype.load = function () {
    var self = this, handles = {};
    this.cfg.lines.forEach(function (l) { self.refs(l).forEach(function (r) { handles[r.h] = true; }); });
    if (this.cfg.product) handles[this.cfg.product] = true;
    var jobs = Object.keys(handles).map(function (h) {
      return fetch("/products/" + encodeURIComponent(h) + ".js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          p.variants.forEach(function (v) {
            self.v[String(v.id)] = { price: v.price, available: v.available, title: p.title,
                                     option: p.variants.length > 1 ? v.title : "", url: p.url || ("/products/" + h), handle: h };
          });
        })
        .catch(function () {});
    });
    Promise.all(jobs).then(function () { self.render(); });
  };

  // every {h, v} a line can resolve to
  Builder.prototype.refs = function (l) {
    if (l.ref) return [l.ref];
    var m = l.by_colour || l.by_finish || {};
    return Object.keys(m).map(function (k) { return m[k]; });
  };

  // the {h, v} a line resolves to for the current choices
  Builder.prototype.pick = function (l) {
    if (l.ref) return l.ref;
    if (l.by_colour) return l.by_colour[this.state.colour];
    if (l.by_finish) return l.by_finish[this.state.finish];
    return null;
  };

  Builder.prototype.current = function () {
    var self = this, s = this.state, rows = [];
    this.cfg.lines.forEach(function (l) {
      if (l.version !== s.version || !s.groups[l.group]) return;
      var r = self.pick(l), info = r && self.v[String(r.v)];
      rows.push({ line: l, ref: r, info: info, qty: l.qty });
    });
    return rows;
  };

  Builder.prototype.versionGroups = function () {
    var s = this.state, have = {};
    this.cfg.lines.forEach(function (l) { if (l.version === s.version) have[l.group] = true; });
    return this.cfg.groups.filter(function (g) { return have[g.id]; });
  };

  Builder.prototype.bundle = function () {
    var s = this.state, self = this;
    var all = this.versionGroups().every(function (g) { return s.groups[g.id]; });
    if (!all) return null;
    var b = (this.cfg.bundles || []).filter(function (b) {
      return b.version === s.version && (b.finish || null) === s.finish && (b.colour || null) === s.colour;
    })[0];
    if (!b) return null;
    var info = self.v[String(b.v)];
    return info ? { b: b, info: info } : null;
  };

  Builder.prototype.versionHasChoice = function (kind) {
    var s = this.state;
    return this.cfg.lines.some(function (l) { return l.version === s.version && l[kind]; });
  };

  Builder.prototype.render = function () {
    var c = this.cfg, s = this.state, self = this, h = [];
    var radios = function (name, items, cur) {
      return '<div class="nba-kb-opts" role="radiogroup">' + items.map(function (it) {
        var id = typeof it === "string" ? it : it.id, label = typeof it === "string" ? it : it.name;
        return '<label class="nba-kb-opt' + (id === cur ? " is-on" : "") + '"><input type="radio" name="' + name + '" value="' +
          esc(id) + '"' + (id === cur ? " checked" : "") + "><span>" + esc(label) + "</span></label>";
      }).join("") + "</div>";
    };
    if (c.versions.length > 1) h.push('<fieldset><legend>Version</legend>' + radios("version", c.versions, s.version) + "</fieldset>");
    if (c.finishes.length && this.versionHasChoice("by_finish"))
      h.push('<fieldset><legend>Cabinet finish</legend>' + radios("finish", c.finishes, s.finish) + "</fieldset>");
    if (c.colours.length && this.versionHasChoice("by_colour"))
      h.push('<fieldset><legend>Driver colours</legend>' + radios("colour", c.colours, s.colour) + "</fieldset>");
    var groups = this.versionGroups();
    if (groups.length > 1) {
      h.push('<fieldset><legend>What\'s included</legend><div class="nba-kb-opts">' + groups.map(function (g) {
        return '<label class="nba-kb-opt nba-kb-check' + (s.groups[g.id] ? " is-on" : "") + '"><input type="checkbox" name="group" value="' +
          esc(g.id) + '"' + (s.groups[g.id] ? " checked" : "") + "><span>" + esc(g.name) + "</span></label>";
      }).join("") + "</div></fieldset>");
    }
    var rows = this.current(), total = 0, missing = [], unknown = [];
    var list = rows.map(function (r) {
      var i = r.info, price = i ? i.price * r.qty : 0;
      if (!i) unknown.push(r.line.label);
      else if (!i.available) missing.push(i.title);
      total += price;
      return '<tr class="' + (i && !i.available ? "is-out" : "") + '"><td class="nba-kb-q">' + r.qty + " ×</td><td>" +
        (i ? '<a href="' + esc(i.url) + '">' + esc(i.title) + "</a>" + (i.option ? ' <span class="nba-kb-dim">' + esc(i.option) + "</span>" : "")
           : esc(r.line.label)) +
        (i && !i.available ? ' <span class="nba-kb-out">sold out</span>' : "") +
        '</td><td class="nba-kb-p">' + (i ? money(price) : "-") + "</td></tr>";
    }).join("");
    h.push('<p class="nba-kb-unit">' + (c.unit === "speaker" ? "For one speaker." : "For a pair of speakers.") + "</p>");
    h.push('<table class="nba-kb-list"><tbody>' + (list || '<tr><td colspan="3">Nothing ticked.</td></tr>') + "</tbody></table>");
    var b = this.bundle(), useBundle = b && b.info.available, out = [];
    if (useBundle) {
      var save = total - b.info.price;
      h.push('<div class="nba-kb-total"><span>Complete kit</span><strong>' + money(b.info.price) + "</strong></div>");
      if (save > 0) h.push('<p class="nba-kb-save">Wagner\'s complete-kit bundle: saves ' + money(save) + " on buying the parts.</p>");
    } else {
      h.push('<div class="nba-kb-total"><span>Total</span><strong>' + money(total) + "</strong></div>");
      if (b && !b.info.available) h.push('<p class="nba-kb-note">The complete-kit bundle is sold out at the moment, so this adds the parts.</p>');
    }
    var blocked = !rows.length || (!useBundle && (missing.length || unknown.length));
    if (!useBundle && missing.length) out.push("Sold out: " + missing.join(", ") + ". Untick it, or check back soon.");
    if (unknown.length) out.push("Not available here: " + unknown.join(", ") + ".");
    h.push('<button type="button" class="button button--full-width nba-kb-add"' + (blocked ? " disabled" : "") + ">" +
      (useBundle ? "Add complete kit to cart" : "Add kit to cart") + "</button>");
    h.push('<p class="nba-kb-msg" role="status">' + esc(out.join(" ")) + "</p>");
    this.root.querySelector("[data-nba-kb-body]").innerHTML = h.join("");
    this.bind(useBundle ? [{ id: Number(b.b.v), quantity: 1 }] :
      rows.filter(function (r) { return r.info && r.info.available; }).map(function (r) { return { id: Number(r.ref.v), quantity: r.qty }; }));
  };

  Builder.prototype.bind = function (items) {
    var self = this, s = this.state, body = this.root.querySelector("[data-nba-kb-body]");
    body.querySelectorAll("input[type=radio]").forEach(function (el) {
      el.addEventListener("change", function () { s[el.name] = el.value; self.render(); });
    });
    body.querySelectorAll("input[name=group]").forEach(function (el) {
      el.addEventListener("change", function () { s.groups[el.value] = el.checked; self.render(); });
    });
    var btn = body.querySelector(".nba-kb-add"), msg = body.querySelector(".nba-kb-msg");
    btn.addEventListener("click", function () {
      btn.disabled = true;
      msg.textContent = "Adding…";
      fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
                              body: JSON.stringify({ items: items, sections: "cart-icon-bubble" }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || "Couldn't add to the cart");
          var bubble = document.getElementById("cart-icon-bubble"), sec = res.j.sections && res.j.sections["cart-icon-bubble"];
          if (bubble && sec) {
            var tmp = document.createElement("div");
            tmp.innerHTML = sec;
            var inner = tmp.querySelector(".shopify-section");
            bubble.innerHTML = inner ? inner.innerHTML : sec;
          }
          msg.innerHTML = 'Added to your cart. <a href="/cart">View cart</a>';
          btn.disabled = false;
        })
        .catch(function (e) { msg.textContent = e.message; btn.disabled = false; });
    });
  };

  function boot() {
    document.querySelectorAll("[data-nba-kb]").forEach(function (el) {
      if (!el.__nbaKb) el.__nbaKb = new Builder(el);
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
})();
